import { Component, ComponentFactoryResolver } from '@angular/core';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Platform } from '@ionic/angular';

import { SharedGlobals } from './service/shared-globals.service';
import { MenuService } from './service/menu.service';
import { DataService } from './service/data.service';

/**  WEBSTRIP 
import { UserService } from './service/user.service';
import { UserDetails } from "./service/user.details";
*/

import { MenuController } from '@ionic/angular';
import { NavController, ModalController } from '@ionic/angular';

import { Storage } from '@ionic/storage';

/**  WEBSTRIP 
//import { OneSignal, OSNotificationPayload } from '@ionic-native/onesignal/ngx';
import OneSignal from 'onesignal-cordova-plugin';
import { Contacts, Contact, ContactName, ContactField } from '@ionic-native/contacts';
*/

import { Events } from './service/events.service';

import { AppWebBrowser } from './service/inapp-browser.service';

import { Router } from '@angular/router';

/**  WEBSTRIP 
import { AuthenticationService } from "./profileproviders/authentication-service/authentication-service";
import { LoginPage } from './profilepages/login/login.page';
import { ProfilePage } from './profilepages/profile/profile.page';
*/



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  //rootPage: any = HomePage;
  rootPostType = 'event';

  logo = '';
  logoRear = '';
  pageTitle = '';
  copyrightText = '';
  pagesFrontMenu: Array<{menuTitle: string, path: string, post_type: string}>;
  pagesRearMenu: Array<{menuTitle: string, path: string, post_type: string}>;
  pagesSocialMenu: Array<{menuTitle: string, path: string, post_type: string}>;
  
  socialGroup = 'columns'; //list //columns
  
  activePage: any;
  
  graphicsArray = [];
  graphic = '';
  graphicBckg = '';
  graphicBckg2 = '';
  graphicClass = '';
  graphicPageBckgStyle: string = '';
  languages = [];
  lang = '';
  languageChanged = false;
  




  // public userservice: UserProvider
  
 
  constructor(public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen, private defaultmenu: MenuService, public sharedGlobals: SharedGlobals, public menuCtrl: MenuController, public modalCtrl: ModalController, public navCtrl: NavController, private appWebBrowser: AppWebBrowser, private storage: Storage, public dataService: DataService, public sharedEvents: Events, private router: Router /**  WEBSTRIP , public authService: AuthenticationService, private userService: UserService*/) { //private oneSignal: OneSignal, 

  
  
    this.initializeApp();

    this.logo = this.sharedGlobals.logoMenu;
    this.logoRear = this.sharedGlobals.logoMenuRear;
    // set global first
    this.sharedGlobals.curDataObj = { menuTitle: 'Programme', path: 'eventlist', post_type: 'loading' };
    
    
    
    this.statusBar.styleDefault();
    //this.splashScreen.hide();
    /** **/
    // splaschreen later, not on initialize - avoid lag
    this.hideSplashScreen();
    
    
    
   
    
    this.lang = this.sharedGlobals.lang;
    
    //this.setActivePage();
    
    this.setUpMenus(); 
    
    this.handleCurUser();
    this.setStoredPass();
    
    
    
    this.router.navigate(['/home']);
    
    
    /**
    
    //this.graphic = 'assets/graphics/SMK-logo-subtext.png';
    //this.graphicBckg = 'assets/graphics/geoSMK.png';
    

    **/

    /** test push 
    setTimeout(() => {
        this.sendTestPush();
        }, 100);   
    **/
         

    
  }
  
  
  



/** hide splashscreen with delay **/
hideSplashScreen() {
    //white screen fix
    if (this.splashScreen) {
    console.log(this.splashScreen);
        setTimeout(() => {
        this.splashScreen.hide();
        }, 2500);
    }
  }
  
  
  
  handleCurUser() {
    this.loaduserdetails();
  }
  
  
  
  loaduserdetails() {
  
  this.sharedGlobals.curLoggedUser = '';

    this.sharedEvents.subscribe('user:ready', (data: any) => {
                //console.log('USER IS READY!');
                //console.log(data.uid);
                this.sharedGlobals.curLoggedUser = data.uid;
                this.setUpMenus();
                
            if (data.state == 'userDetails') {}
    });
    this.sharedEvents.subscribe('user:out', (data: any) => {
                this.sharedGlobals.curLoggedUser = '';
                this.setUpMenus();
                //!!! this.nav.setRoot(this.rootPage);
                
            if (data.state == 'userLoggedOut') {}
            
    });
    
  }
  
  
  
  setUpMenus() {
    
    this.getMenuFromStorageAndServer(true);
  
  }
  
  
  
  setActivePage() {
        //this.activePage = this.rootPage;  
  }
  
  
  
  changeLang(selectedLang: string) {
  console.log('LANG CHANGED!');
    this.languageChanged = true;
    this.sharedGlobals.lang = selectedLang;
    this.lang = selectedLang;
    // this.changeGalleryLang(selectedLang); // not needed

    this.getMenuFromStorageAndServer(false);
  }
  
  changeGalleryLang(selectedLang: string) {
    if (selectedLang != 'si' && selectedLang != 'sl') {
        this.sharedGlobals.imgGalUrlBase = this.sharedGlobals.imgGalUrlBaseDefaultLang + '/' + selectedLang;
    }
    else {
        this.sharedGlobals.imgGalUrlBase = this.sharedGlobals.imgGalUrlBaseDefaultLang;
    }
    
  }
  
  changeCurDataOnLangChange() {
  
        var menuArr = this.pagesFrontMenu;
        let postType = this.sharedGlobals.curDataObj.post_type;
        for (var i = 0; i < menuArr.length; i++) {
            if(menuArr[i].post_type === postType) {
                console.log('FOUND POST TYPE');
                console.log(menuArr[i]);
                this.sharedGlobals.curDataObj = menuArr[i];
                return;
            }
        }
  
        menuArr = this.pagesRearMenu;
        for (var i = 0; i < menuArr.length; i++) {
            if(menuArr[i].post_type === postType) {
                //console.log('FOUND POST TYPE');
                //console.log(menuArr[i]);
                this.sharedGlobals.curDataObj = menuArr[i];
                return;
            }
        }
        
        console.log('CHANGE CUR DATA ON LANG CHANGE');
        this.sharedGlobals.firstPageWasSet = false;
        this.setFirstPage();
  }
  
  
  
  
  getMenuFromStorageAndServer(getFromServer:boolean = false) {
  
  var menus: any;
  //storage
    this.storage.get('menus').then((val) => { 
    
                /** delete this
                if(this.sharedGlobals.menusAreSet) {
                    return; // server was faster;
                }
                **/
                
    
            if (val) {
                menus = JSON.parse(val);
                
                this.pagesFrontMenu = this.defaultmenu.convertMenu(menus.menu_front[this.lang]);
                this.pagesRearMenu = this.defaultmenu.convertMenu(menus.menu_rear[this.lang]);
                this.pagesSocialMenu = this.defaultmenu.convertMenu(menus.social_links);
                
                this.copyrightText = menus.copyright_text[this.lang];
                this.graphicsArray = menus.graphics_rand[this.lang];
                this.setGraphic();
                
                
                this.sharedGlobals.globalPreferences = menus.preferences;
                
                
                if(menus.preferences) {
                    if(menus.preferences.contentUpdateInterval) {
                        this.sharedGlobals.contentUpdateInterval = menus.preferences.contentUpdateInterval.toString();
                    }
                    if(menus.preferences.passkey) {
                        this.sharedGlobals.passkey = menus.preferences.passkey.toString();
                    }
                    if(menus.preferences.showEventDates) {
                        this.sharedGlobals.showEventDates = menus.preferences.showEventDates.toString();
                    }
                    if(menus.preferences.showEventEndDates) {
                        this.sharedGlobals.showEventEndDates = menus.preferences.showEventEndDates.toString();
                    }
                    if(menus.preferences.startPage && !this.sharedGlobals.notificationPageOpen) {
                        this.sharedGlobals.startPage["menu"] = menus.preferences.startPage.menu.toString();
                        this.sharedGlobals.startPage["menuItem"] = menus.preferences.startPage.menuItem.toString();
                        this.sharedGlobals.startPage["detailId"] = menus.preferences.startPage.detailId.toString();
                        this.sharedGlobals.startPage["closeMenu"] = menus.preferences.startPage.closeMenu.toString();
                        //console.log(this.sharedGlobals.startPage);
                    }
                }
                
                this.sharedGlobals.eventName = menus.lang_dict.event_name;
                this.sharedGlobals.slogan = menus.lang_dict.slogan;
                this.sharedGlobals.languages = menus.languages;
                this.sharedGlobals.langDict = menus.lang_dict;
                this.languages = this.sharedGlobals.languages;
                
                
                /**
                console.log('menus are set - FROM STORAGE');
                this.sharedGlobals.menusAreSet = true; //menus are set
                **/
                
                
            }
            else {
                this.pagesFrontMenu = this.defaultmenu.getMenuFront();
                this.pagesRearMenu = this.defaultmenu.getMenuRear();
                this.pagesSocialMenu = [];
                
                this.copyrightText = (new Date()).getFullYear() + ' ©<br>' + this.sharedGlobals.eventName; //default
                this.graphicsArray = this.defaultmenu.getDefaultGraphics();
                this.setGraphic();
                
                this.sharedGlobals.dateMenuUpdated = false;
            }
            
            if(getFromServer) {
                this.getMenuFromServer();
            }
            
                  
            //notify root controller that data is loaded from storage now - for first load (pass protection etc...)
            this.sharedGlobals.contentReady = 1;
            
            if (this.sharedGlobals.contentReady === 1 && this.sharedGlobals.passReady === 1) {
                this.onContentIsReadyAndPassIsReady();
            }
            
            
            
            if (this.languageChanged) {
                this.changeCurDataOnLangChange();
                //this.openPage(this.sharedGlobals.curDataObj);
                this.router.navigate(['/home']);
                this.languageChanged = false;
            }
            
            
            
            
        });
  
  }
  
  
  
  
  
  
  onContentIsReadyAndPassIsReady() {
  
        if (this.sharedGlobals.firstPageWasSet) {
            this.sharedGlobals.contentPassReady = 1;
            this.sharedEvents.publish('contentandpass', {
                state: "ready"
            });
            
        }
        
  }
  
  
  
  
  
  
  
  
  
  
  getMenuFromServer() {
  
  var menuNotLoaded = true;
  
  var menus: any;
    //server
    var ds = this.dataService.getMenus()
       .subscribe(resPostsData => {
    
            if (resPostsData) {
                
                console.log("Menus: " + resPostsData)
                menus = resPostsData;
                this.dataService.addObjectsToStorage(menus, 'menus'); 
                
                this.pagesFrontMenu = this.defaultmenu.convertMenu(menus.menu_front[this.lang]);
                this.pagesRearMenu = this.defaultmenu.convertMenu(menus.menu_rear[this.lang]);
                this.pagesSocialMenu = this.defaultmenu.convertMenu(menus.social_links);
                
                this.copyrightText = menus.copyright_text[this.lang];
                this.graphicsArray = menus.graphics_rand[this.lang];
                this.setGraphic(); // only call this if not randomly selecting imgs..
                 
                // set updated date
                var dateNow = (new Date).getTime();
                this.sharedGlobals.dateMenuUpdated = dateNow;
                
                //this.setGlobalCurData(this.pagesFrontMenu);
                
                this.sharedGlobals.globalPreferences = menus.preferences;
                if(menus.preferences) {
                    if(menus.preferences.contentUpdateInterval) {
                        this.sharedGlobals.contentUpdateInterval = menus.preferences.contentUpdateInterval.toString();
                    }
                    if(menus.preferences.passkey) {
                        this.sharedGlobals.passkey = menus.preferences.passkey.toString();
                    }
                    if(menus.preferences.showEventDates) {
                        this.sharedGlobals.showEventDates = menus.preferences.showEventDates.toString();
                    }
                    if(menus.preferences.showEventEndDates) {
                        this.sharedGlobals.showEventEndDates = menus.preferences.showEventEndDates.toString();
                    }
                    if(menus.preferences.startPage && !this.sharedGlobals.notificationPageOpen) {
                        this.sharedGlobals.startPage["menu"] = menus.preferences.startPage.menu.toString();
                        this.sharedGlobals.startPage["menuItem"] = menus.preferences.startPage.menuItem.toString();
                        this.sharedGlobals.startPage["detailId"] = menus.preferences.startPage.detailId.toString();
                        this.sharedGlobals.startPage["closeMenu"] = menus.preferences.startPage.closeMenu.toString();
                        //console.log(this.sharedGlobals.startPage);
                    }
                }
                
                this.sharedGlobals.eventName = menus.lang_dict.event_name;
                this.sharedGlobals.slogan = menus.lang_dict.slogan;
                this.sharedGlobals.languages = menus.languages;
                this.sharedGlobals.langDict = menus.lang_dict;
                this.languages = this.sharedGlobals.languages;
                
                
                // open first page
                menuNotLoaded = false;
                this.setFirstPage();
                this.onContentIsReadyAndPassIsReady(); // call to start sending sharedEvents message
                
            } 
            
            
            
            ds.unsubscribe;
       })
       
       
       setTimeout(() => {
                // open first page anyway if no connection... 
                if (menuNotLoaded) {
                    this.setFirstPage();
                    this.onContentIsReadyAndPassIsReady(); // call to allow sending sharedEvents message
                }  
        }, 5000);
       
       
  }
  
  
  
  
  
  setFirstPage() {
  
            if(!this.pagesFrontMenu || !this.pagesRearMenu) {
                return;
            }
            
            // if it was already set and it is not pushOpen return...
            if(this.sharedGlobals.firstPageWasSet && !this.sharedGlobals.notificationPageOpen) {
                return;
            }
            
            
            
    
  
  
            console.log('SET FIRST PAGE CALLED');
            this.sharedGlobals.menuOpenOnLoad = true;
  
            let pageMenu = this.sharedGlobals.startPage["menu"];
            if (pageMenu > 1) {pageMenu = 0;} // if not front or rear, set front
            let pageStartNum = this.sharedGlobals.startPage["menuItem"]; 
            let openMenuNum = 0;
            let openPageNum = 0;
            
            
            
            
            let openCurDataObject = this.sharedGlobals.curDataObj; //set var, so it does not get overriden by sharedEvents
            if (pageMenu == 1 && this.pagesRearMenu) {
                if (pageStartNum < this.pagesRearMenu.length) {
                    openCurDataObject = this.pagesRearMenu[pageStartNum];
                }
            }
            if (pageMenu != 1 && this.pagesFrontMenu) {
                if (pageStartNum < this.pagesFrontMenu.length) {
                    openCurDataObject = this.pagesFrontMenu[pageStartNum];
                }
            }
            
            
            
                    /** maybe open detail page directly - notifications etc **/
                    if (this.sharedGlobals.startPage["detailId"] && this.sharedGlobals.startPage["detailId"] != "-1") {
                        console.log('OPENING DETAIL PAGE');
                        openCurDataObject.post_open_id = this.sharedGlobals.startPage["detailId"];
                        openCurDataObject.post_open = 'opensingle';
                        openCurDataObject.openFrom = 'menu';
                        openCurDataObject.closeMenu = this.sharedGlobals.startPage["closeMenu"];
                        openCurDataObject.path = 'detail/'+openCurDataObject.post_open_id;
                    }
            
            
            //this.sharedGlobals.curDataObj = openCurDataObject; //not ok DELETE
            console.log("open page");
            console.log(openCurDataObject);
            this.openPage(openCurDataObject);
            this.sharedGlobals.firstPageWasSet = true;
            
            
            console.log('OPEN MENU!');
            //this.menuCtrl.open();
            
            
            this.closeMenuIfNeeded(); //close it directly from page...
            
            
            this.sharedGlobals.notificationPageOpen = false;
            
  }
  
  
  
  
  
  /** not in use 
  openDetailPageDirectly(detailId) {
        // this.sharedGlobals.openDetail = true
        this.sharedGlobals.curDataObj.post_open_id = this.sharedGlobals.startPage["detailId"];
        this.sharedGlobals.curDataObj.post_open = 'opensingle';
        this.sharedGlobals.curDataObj.path = 'detail';
        this.openPage(this.sharedGlobals.curDataObj);
        this.closeMenuIfNeeded();
  }
  
  **/
  
  
  closeMenuIfNeeded() {
  console.log('Close menu if needed');
  console.log(this.sharedGlobals.startPage["closeMenu"]);
            if (this.sharedGlobals.startPage["closeMenu"] && this.sharedGlobals.startPage["closeMenu"] == "1") {
                this.menuCtrl.close();
                console.log('CLOSE MENU CALLED!');
            } else {
                this.menuCtrl.open();
                console.log('OPEN MENU CALLED!');
            }
  }
  
  
  
  
  
  
  /**
  setGlobalCurData(menuArr) {
  
    for (var i = 0; i < menuArr.length; i++) {
        if(menuArr[i].post_type === this.rootPostType) {
            this.sharedGlobals.curDataObj = menuArr[i];
            //console.log('NEW GLOBAL CUR DATA:');
            //console.log(this.sharedGlobals.curDataObj);
            break;
        }
    }
  }
  **/
  
  
  
  setStoredPass() {
  
    this.storage.get('passkey_entered').then((val) => {
            if(val) {
                this.sharedGlobals.passkey_entered = val;
            } 
            this.sharedGlobals.passReady = 1;
            console.log('PASS IS READY!')
            
            if (this.sharedGlobals.contentReady === 1 && this.sharedGlobals.passReady === 1) {
                this.onContentIsReadyAndPassIsReady();
            }
            
            
            
     });
    
  }
  




  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      //this.statusBar.styleDefault();
      //this.splashScreen.hide();
      
      if (this.platform.is('cordova')) {
        this.setOneSignal();
        }
      
    });
   
    this.menuCtrl.swipeGesture(false, 'menu1');
    this.menuCtrl.swipeGesture(false, 'menu2');
  }
  

  
  addPlayerIdToStorage(playerId: string) {
    try {
        this.storage.set('curPlayerId', playerId);
      } catch (error) {
        console.log(error)
      }
   }
   
  

  setOneSignal(): void {
   
  }


  
  

  /*
  setOneSignal() {
    
    //console.log('Set OneSignal');                                       
    this.oneSignal.startInit('289c6366-460f-4a73-a3df-c37b01ffebd3', '897458846339'); // Second param is Google app number

    //this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert); // this was messing with local notfs - https://github.com/katzer/cordova-plugin-local-notifications/issues/1171
    
    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);
    
    // do something when notification is received
    this.oneSignal.handleNotificationReceived().subscribe(data => this.onPushReceived(data.payload));
    
    // do something when a notification is opened
	this.oneSignal.handleNotificationOpened().subscribe(data => this.onPushOpened(data.notification.payload));

    this.oneSignal.endInit();
    
  }
  
  
  private onPushReceived(payload: OSNotificationPayload) {
	//alert('Push recevied:' + payload.body);
  }

  private onPushOpened(payload: OSNotificationPayload) {
  
    this.sharedGlobals.notificationPageOpen = true;   // prevent override on menu load
	//alert('Push opened: ' + payload.additionalData);

    if (payload && payload.additionalData) {
      let data = payload.additionalData;
      if (data["menu"] && data["menuItem"] ) {
      
            this.sharedGlobals.startPage["menu"] = data["menu"].toString();
            this.sharedGlobals.startPage["menuItem"] = data["menuItem"].toString();
            this.sharedGlobals.startPage["detailId"] = "-1";
            this.sharedGlobals.startPage["closeMenu"] = "1"; // close menu as default, if called from push  
      
            if (data["detailId"]) {
                this.sharedGlobals.startPage["detailId"] = data["detailId"].toString();
            }
            if (data["closeMenu"]) {
                this.sharedGlobals.startPage["closeMenu"] = data["closeMenu"].toString();
            }
            
            if (this.sharedGlobals.contentPassReady == 1 && this.sharedGlobals.notificationPageOpen) {   // if menu was already loaded (app is open) set first page, else do it later on content && pass ready event
                    console.log('Opening Page With Push');
                    //this.setFirstPage();
                    this.sharedGlobals.notificationPageOpen = false;
            }
      }
      }
      
  }
  */
  
  
  
  
  
  /** TESTING PUSH **/
  private testPushOpen(payload) {
    //this.onPushOpened(payload);
  }
  
  
  private sendTestPush() {
  
  var payload: any = {};
  var additionalData: any = {};
  
  additionalData["menu"] = "0"; // menuFront/menuRear
  additionalData["menuItem"] = "5";  // menuItem 0/1/2/etc...
  additionalData["detailId"] = "14416"; // this example-> open post with id "14416" from menu item number "5" on front menu "0"...
  additionalData["closeMenu"] = "1";  // Show or hide menu ? show menu: 0 / hide menu: 1
  
  
  payload["additionalData"] = additionalData;
  
  console.log('OPEN UP!!!');
  console.log(payload.additionalData); //this is wrong formatting, but it works for testing
  
  this.testPushOpen(payload);
  
  }
  
  
  
  
  

  openPage(page) {
  console.log('OPEN PAGE')
    
    if (page.post_type === 'openbrowser') {
        this.appWebBrowser.openWithInAppBrowser(page.url); 
    }
    else if (page.post_type === 'openprofilebrowser') {
        this.appWebBrowser.openWithInAppBrowserUserProfile(page.url); 
    }
    else if (page.post_type === 'userprofile') {
    // set curData object global
            this.presentUserProfileModal(); 
    }
    else if (page.post_open === 'opensingle') { // open detail directly
    
    // set curData object global
    this.sharedGlobals.curDataObj = page;
    
        //console.log('OPEN SINGLE');
    
        // Reset the content nav to have just this page
        // set empty content, then load contents from the Details controller
        //!!! this.nav.setRoot(page.component, {"item":{"title":page.menuTitle, "id":page.post_open_id, "content":"", "openFrom":"menu"}, "curPostType": page.post_type, "data_url": page.data_url, "post_open_id":page.post_open_id});

        let item = page;
        //console.log(item);
        
        /** make transition **/
        this.dataService.setPassingPostObject(item);
        //this.router.navigate(['/detail/'+item.post_open_id]);
        
        this.navCtrl.navigateForward(['/detail/'+item.post_open_id], { animated: false, });
    
    }
    else {
    
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    //!!! this.nav.setRoot(page.component);
    
    // set curData object global
    this.sharedGlobals.curDataObj = page;
    
    // use nav ctrl, so you can disable animation for menu transition
    this.navCtrl.navigateForward([page.path], { animated: false, });
    //this.router.navigate([page.path]); 
    
        
    }
    
    this.activePage = page;
        
  }
  
  
  
  presentUserProfileModal() {
    
        if (this.sharedGlobals.curLoggedUser === '') {
            /** MODAL CTRL
            const modal = await this.modalCtrl.create({
                component: LoginPage,
                cssClass: 'app-login'
            });
            return await modal.present();
            **/
            
            this.router.navigate(['/login'])
            return
        }
        else {
            
            this.router.navigate(['/profile'])
            return
           
        }
        
        
        
            
    // userProfile.present();

  }
  

  
  
  
  setGraphic() {
  
    // random number
    if(this.graphicsArray && this.graphicsArray.length > 0) {
        var ind = Math.floor((Math.random() * this.graphicsArray.length) + 0);
  
    this.graphic = this.graphicsArray[ind].img;
    this.graphicBckg = this.graphicsArray[ind].img_bckg;
    this.graphicBckg2 = this.graphicsArray[ind].img_bckg2;
    this.graphicClass = this.graphicsArray[ind].class;
    
    this.graphicPageBckgStyle = 'background-image:url(' + this.graphicBckg + ')';
    
    }
    
    

  
  }
  
 
  
  
   menuClose(id) {
        this.menuCtrl.close(id); 
        this.menuClosed();
   }
  
  
  
  
   menuClosed() {
    
    //!!! this.closeMenuFix1.nativeElement.style.display = "none";
    //console.log(this.graphicsArray);
    this.setGraphic();
    
    if(this.menuNeedsUpdating()) {
        this.getMenuFromServer();
    }
    this.sharedGlobals.menuIsOpen = false;
    console.log(this.sharedGlobals.menuIsOpen);
    
   }


  menuOpened(id) {
    
    /** !!!
    if (id === 'menu1') {
        this.closeMenuFix1.nativeElement.style.display = "block";
    }
    **/
    this.sharedGlobals.menuIsOpen = true;
    console.log(this.sharedGlobals.menuIsOpen);
    
   }
   
   
   
   checkActive(page) {
    return page.menuTitle == this.sharedGlobals.curDataObj.menuTitle;
   }
   
   
   checkActiveLang(lang) {
    return lang == this.sharedGlobals.lang;
   }
   
   
   menuNeedsUpdating() {
        var dateUpdated = this.sharedGlobals.dateMenuUpdated;
        if (dateUpdated) {
            dateUpdated = (new Date(dateUpdated + 2*60000)).getTime(); //add 3mins
        }
        
        
        var dateNow = (new Date).getTime();
        
        if (dateUpdated == false || dateUpdated < dateNow) {
            return true;
        }
        
        return true;
   }
   
   
   
  
  
}

